export default function SectionLabel({ children, className = "" }) {
  return (
    <div className={`inline-flex items-center gap-3 ${className}`}>
      <span className="h-px w-8 bg-[#D4AF37]" />
      <span className="font-mono text-[10px] uppercase tracking-[0.35em] text-[#D4AF37]">
        {children}
      </span>
    </div>
  );
}
